import { IconOption1 } from "../assets/CoinsIconsOptions/IconOption1";
import { IconOption2 } from "../assets/CoinsIconsOptions/IconOption2";
import { IconOption3 } from "../assets/CoinsIconsOptions/IconOption3";
import { IconOption5 } from "../assets/CoinsIconsOptions/IconOption5";
import { IconOption6 } from "../assets/CoinsIconsOptions/IconOption6";
import { IconOption7 } from "../assets/CoinsIconsOptions/IconOption7";
import { IconOption8 } from "../assets/CoinsIconsOptions/IconOption8";
import { IconOption9 } from "../assets/CoinsIconsOptions/IconOption9";
import { IconOption10 } from "../assets/CoinsIconsOptions/IconOption10";
import { IconOption4 } from "../assets/CoinsIconsOptions/Iconoption4";

export const coinsIcons = [
  {
    id: 1,
    value: "fa-gem1",
    icon: <IconOption1 />,
  },
  {
    id: 2,
    value: "fa-gem2",
    icon: <IconOption2 />,
  },
  {
    id: 3,
    value: "fa-gem3",
    icon: <IconOption3 />,
  },
  {
    id: 4,
    value: "fa-trophy",
    icon: <IconOption4 />,
  },
  {
    id: 5,
    value: "fa-stamp",
    icon: <IconOption5 />,
  },
  {
    id: 6,
    value: "fa-star",
    icon: <IconOption6 />,
  },
  {
    id: 7,
    value: "fa-coin1",
    icon: <IconOption7 />,
  },
  {
    id: 8,
    value: "fa-coin2",
    icon: <IconOption8 />,
  },
  {
    id: 9,
    value: "fa-cash1",
    icon: <IconOption9 />,
  },
  {
    id: 10,
    value: "fa-cash2",
    icon: <IconOption10 />,
  },
];
